export default __webpack_public_path__ + "static/media/location_outline.715c803e.svg";